module.exports = __webpack_public_path__ + "static/img/partner-logo.195e7186.png";